import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const Subscribe = createAction('[Subscriptions] Subscribe to Newsletter', props<{ email: string }>());
export const SubscribeSuccess = createAction('[Subscriptions] Subscribe to Newsletter Success', props<{ subscription: any }>());
export const SubscribeFail = createAction('[Subscriptions] Subscribe to Newsletter Fail', props<{ error: HttpErrorResponse }>());
